import EntradaMercadoriaService from "@/services/EntradaMercadoriaService";
import { router } from "@/router";
import helper from "@/helper";
import moment from "moment";
import store from "@/store";

export const actions = {
  cadastrarEntradaMercadoria: ({ commit, dispatch }) => {
    commit("setEntradaMercadoria", {
      id: "",
      fornecedor_id: "",
      numero_nota: "",
      numero_serie: "",
      cfop: "",
      data_emissao: moment().format("YYYY-MM-DD"),
      data_entrada: moment().format("YYYY-MM-DD"),
      total: "0,00",
      itens: [],
      status: "",
      chave_nfe: "",
      transportadora_id: "",
      valor_frete: "0,00",
      estoque_id: 1,
      modalidade_frete: "FOB",
      total_produtos: "0,00",
      desconto: "0,00",
    });

    commit("setItensEntradaMercadoria", []);
    commit("setContasPagarEntradaMercadoria", []);
    router.push({ name: "entradaMercadoriaCadastro" });
  },
  listarEntradaMercadoria: ({ commit }, data) => {
    commit("setOverlay", true);
    EntradaMercadoriaService.listar(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setPerfis", res.data);
        commit("setEntradasMercadorias", res.data);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  visualizarEntradasMercadorias:() => {
    router.push({name: 'entradaMercadoria'})
  },
  visualizarEntradaMercadoria: ({ commit, dispatch }, id) => {
    commit("setOverlay", true);
    commit("setItensEntradaMercadoria", []);
    commit("setContasPagarEntradaMercadoria", []);
    EntradaMercadoriaService.editar(id).then((res) => {
      const data = res.data;
      data.desconto = res.data.desconto ? helper.formatReal(parseFloat(res.data.desconto)) : "0,00";
      data.total = res.data.total ? helper.formatReal(parseFloat(res.data.total)) : "0,00";
      data.total_produtos = res.data.total_produtos
        ? helper.formatReal(parseFloat(res.data.total_produtos))
        : "0,00";

        data.contas_pagar.map((i) => {
          commit("addContaPagarEntradaMercadoria", {
            id: i.id,
            valor: helper.formatReal(parseFloat(i.valor)),
            data_vencimento: i.data_vencimento,
            forma_pagamento: i.forma_pagamento,
            grupo_nome: i.grupo.nome,
            grupo_id: i.grupo_id,
            fornecedor_id: i.fornecedor_id,
            fornecedor_nome: i.fornecedor.nome,
          });
        });

        data.itens.map((i) => {
          commit('addItemEntradaMercadoria', {
            produto_id: i.produto_id,
            descricao: i.descricao,
            quantidade: i.quantidade,
            quantidade_nota_entrada: i.quantidade_nota_entrada,
            total_custo: helper.formatReal(parseFloat(i.total_custo)),
            preco_custo: helper.formatReal(parseFloat(i.preco_custo)),
            unidade: i.unidade,
            unidade_nota_entrada: i.unidade_nota_entrada,
            quantidade: i.quantidade,
            grade_id: i.grade_id
          })
        });

        commit("setEntradaMercadoria", data);
        commit("setOverlay", false);
        if (data.fornecedor_id) {
          commit("setContato", data.fornecedor);
        }
    })
    .catch(e => {
      commit("snackbarError", "Erro ao cadastrar.");
      commit("setOverlay", false);
      console.log(e)
    })
  
  },

  salvarEntradaMercadoria: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    EntradaMercadoriaService.salvar(data)
      .then((res) => {
        data = res.data;
        data.total = helper.formatReal(parseFloat(res.data.total));
        commit("setEntradaMercadoria", data);
        commit("setOverlay", false);
        if (res.data.status == "Finalizado") {
          commit("setEntradaMercadoria", {
            ...store.getters.getEntradaMercadoria,
            status: "Finalizado",
          });
          commit("snackbarSuccess", "Entrada de mercadoria finalizada.");
        } else {
          commit("snackbarSuccess", "Entrada de mercadoria salva.");
        }
        router.push({
          name: "entradaMercadoriaEditar",
          params: { id: res.data.id },
        });
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao cadastrar.");
      });
  },
  atualizarEntradaMercadoria: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    EntradaMercadoriaService.atualizar(data)
      .then((res) => {
        commit("setOverlay", false);
        if (res.data.status == "Finalizado") {
          commit("setEntradaMercadoria", {
            ...store.getters.getEntradaMercadoria,
            status: "Finalizado",
          });
          commit("snackbarSuccess", "Entrada de mercadoria finalizada.");
        } else {
          commit("snackbarSuccess", "Entrada de mercadoria atualizada.");
        }
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao atualizar.");
      });
  },
};

export default {};
